import { LANGUAGE } from "@stores/SettingsStore";

/**
 * The app language for a browser language tag ("de-AT", "uk", "ro_MD").
 * Only the primary subtag matters, so every regional variant of a supported
 * language gets that language. The old per-language allowlists covered only
 * en/es/ru/ro/hu, so a Ukrainian, Polish, German or French browser started in
 * English. Anything unsupported falls back to English.
 */
const getLanguageByCode = (code: string | undefined | null): LANGUAGE => {
  const primary = (code ?? "").toLowerCase().split(/[-_]/)[0];
  const match = Object.values(LANGUAGE).find((l) => l.toLowerCase() === primary);
  return match ?? LANGUAGE.EN;
};
export default getLanguageByCode;
